import apiFetch from '../apiFetch'

export default function (token, paymentMethodId) {
  return apiFetch({ endPoint: 'paymentMethod/' + paymentMethodId, method: 'GET', token: token })
}
